import type { ConceptionSizeParameters } from 'src/components/restructure/product/types/product'

export function formatTableData(rawData: ConceptionSizeParameters) {
  const allSizeLabels = rawData.map((item) =>
    item.sizes.map((size) => size.label)
  )

  const tableHeaderY = allSizeLabels.reduce((acc, labels) => {
    return acc.filter((label) => labels.includes(label))
  })

  const tableHeaderX = rawData.map((data) => {
    const { name } = data
    const unitOfReference = data.unit_of_reference

    let header = name

    if (unitOfReference !== null) {
      header = `${header} (${unitOfReference})`
    }

    return header
  })

  return {
    tableHeaderX,
    tableHeaderY,
  }
}
